import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {NavigationService} from '@ispm/navigation/services/navigation.service';
import {takeUntil} from 'rxjs/operators';
import { isEmpty } from "lodash";
import {DisclaimerModalComponent} from '@ispm/layout/components/modals/disclaimer-modal/disclaimer-modal.component';
import {WarningModalLoaderPayload} from '@ispm/layout/classes/warning-modal-loader-payload';
import {DisclaimerService} from '@ispm/dashboard/disclaimer-viewer/services/disclaimer.service';
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';

@Component({
	selector: 'ispm-disclaimer-viewer',
	templateUrl: './disclaimer-viewer.component.html',
	styleUrls: ['./disclaimer-viewer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisclaimerViewerComponent implements OnInit , OnDestroy {
	@Input() title = '';
	@Input() text = '';
	@Input() showDisclaimerModel = false;
	@Input() approveBtnText = 'I_ACKNOWLEDGE';
  @Input() disclamerConfig: {
    text?: string;
    title?: string;
    disclamerViewType?: "icon" | "text";
    showFirstTimePopup?: boolean;
  } = { };
	showDisclaimerIcon = false;
	private destroyed$: Subject<any> = new Subject();

	constructor(
		private _authService: AuthenticationService,
		private _navigationService: NavigationService,
		private _changeDetector: ChangeDetectorRef,
		private _disclaimerService: DisclaimerService,
		private _userActionCreatorService: UserActionCreatorService
	) {
	}

	public ngOnDestroy(): void {
		this.destroyed$.next();
		this.destroyed$.complete();
		this._changeDetector.detach();
	}

	verifyAndDisplayDisclamerWindow() {
		this._userActionCreatorService.getCurrentUser().pipe(takeUntil(this.destroyed$.asObservable()))
			.subscribe(user => {
        if(isEmpty(user)){
          return;
        }
				if (this.showDisclaimerModel) {
					//If disclamer message was displayed before (or no disclamer message was needed), do not get practitioner
					const practitionerObj = JSON.parse(sessionStorage.getItem("disclamerConfig"));
					if (practitionerObj && practitionerObj.practitionerId === user.id && practitionerObj.seenDisclaimer){
						return;
					}
					this._disclaimerService.getPractitioner(user.id).pipe(takeUntil(this.destroyed$.asObservable())).subscribe(practitioner => {
						sessionStorage.setItem('disclamerConfig', JSON.stringify({practitionerId: user.id, seenDisclaimer: true}));
						const disclaimerNeeded = !(practitionerObj && practitionerObj.practitionerId === user.id && practitionerObj.seenDisclaimer);
						if (!practitioner.seenDisclaimer && disclaimerNeeded && !this._authService.user.isAdmin) {
							this._disclaimerService.openDisclaimerModel({
								practitionerId: user.id,
								component: DisclaimerModalComponent,
								payload: new WarningModalLoaderPayload(this.title, this.text, this.approveBtnText),
							}).subscribe(res => {
								// debugger;
								// if (res)
								// 	this.reviseCompleted.emit(res);
							});
						}
					});
				}
			});
	}

  ngOnInit() {
    this.showDisclaimerIcon = true;
    if (!this._authService.user.isAdmin) {
      this.verifyAndDisplayDisclamerWindow();
    }
  }
}
